// extracted by mini-css-extract-plugin
export default {"container":"home_container__7gXWr","content_wrapper":"home_content_wrapper__Bncrk","image":"home_image__nVnt1","text_wrapper":"home_text_wrapper__-JWUr","title":"home_title__FpcVK"};